import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonMui } from 'src/components/ButtonMui'
import Table from 'src/features/base/components/Table'
import { selectProductBarcodes } from 'src/features/stock-management/StockManagementSeletor'
import DeleteBarcodeModal from '../DeleteBarcodeModal'
import InsertBarcodeModal from '../InsertBarcodeModal'
import columns from './BarcodesTable.columns'
import * as S from './BarcodesTable.styles'
import { actions } from 'src/features/stock-management/StockManagementState'

export default () => {
  const [selected, setSelected] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showInsertModal, setShowInsertModal] = useState(false)
  const [selectedBarcode, setSelectedBarcode] = useState()
  const [selectedModelId, setSelectedModelId] = useState([])
  const [rowSelectedState, setRowSelectedState] = useState<any>()
  const [sortedTableRows, setSortedTableRows] = useState<any[]>([])
  const barcodes = useSelector(selectProductBarcodes)

  const dispatch = useDispatch()

  const onRowDoubleClick = (state, rowInfo) => ({
    onClick: () => {
      const rowSelected = rowInfo.original
      setSelectedBarcode(rowInfo.original.barcode)
      setSelectedModelId(rowInfo.original.modelId)
      setSelected(true)
      setRowSelectedState(rowSelected)
    },
    style: {
      backgroundColor:
        rowInfo
        && rowInfo.original
        && rowSelectedState
        && rowInfo.original.barcode === rowSelectedState.barcode
          ? '#a19f9f'
          : 'initial',
    },
  })

  const onClickUpOrder = (b, m, o) => {
    dispatch(actions.upBarcodeOrder({
      barcode: b, type: 'up', modelId: m, order: o,
    }))
  }

  const onClickDownOrder = (b, m, o) => {
    dispatch(actions.downBarcodeOrder({
      barcode: b, type: 'down', modelId: m, order: o,
    }))
  }

  const tableRows = sortedTableRows.map((barcode) => ({
    ...barcode,
    barcode: barcode.barcode,
    order: barcode.barcodeOrder,
    type: barcode.type,
    packQty: barcode.packQty,
    upOrder: barcode.type === 'EAN' ? (
      <S.ArrowUpIcon
        onClick={() => onClickUpOrder(barcode.barcode, barcode.modelId, barcode.barcodeOrder)}
        data-testid='up-arrow-test-id'
      />
    ) : null,
    downOrder: barcode.type === 'EAN' ? (
      <S.ArrowDownIcon
        onClick={() => onClickDownOrder(barcode.barcode, barcode.modelId, barcode.barcodeOrder)}
        data-testid='down-arrow-test-id'
      />
    ) : null,
  }))

  useEffect(() => {
    const sortedEanBarcodes = barcodes
      .filter((barcode) => barcode.type === 'EAN')
      .sort((a, b) => {
        if (a.barcodeOrder === null && b.barcodeOrder === null) {
          return 0
        }
        if (a.barcodeOrder === null) {
          return 1
        }
        if (b.barcodeOrder === null) {
          return -1
        }
        return a.barcodeOrder - b.barcodeOrder
      })

    const sortedDunBarcodes = barcodes
      .filter((barcode) => barcode.type === 'DUN')
      .sort((a, b) => a.packQty - b.packQty)

    setSortedTableRows([...sortedEanBarcodes, ...sortedDunBarcodes])
  }, [barcodes])

  return (
    <>
      <S.Container>
        <ButtonMui
          title='Inserir Código de Barras'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          onClick={() => setShowInsertModal(true)}
          testId='insert-barcode-button-test-id'
        />
        <ButtonMui
          title='Excluir Código de Barras'
          disabled={!selected}
          bgColor='cancel'
          hoverColor='cancelHover'
          letterColor='white'
          onClick={() => setShowDeleteModal(true)}
        />
      </S.Container>
      <Table
        data={tableRows}
        columns={columns}
        onRowDoubleClick={onRowDoubleClick}
        testId='barcodes-table-test-id'
      />
      <DeleteBarcodeModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        barcode={selectedBarcode}
        modelId={selectedModelId}
        setSelected={setSelected}
      />
      <InsertBarcodeModal
        showModal={showInsertModal}
        setShowModal={setShowInsertModal}
      />
    </>
  )
}
